export default __webpack_public_path__ + "static/media/settings.e26681a0.png";